define(function(require, exports, module) {

    'use strict';

    module.exports = function() {

    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/portal/portal.js
// module id = 20
// module chunks = 0